module.exports = __webpack_public_path__ + "static/media/user_2.857269aa.png";